module.exports = __webpack_public_path__ + "static/img/wall-conveyor-x2-steel_64.6f696e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-x2-steel_64.png
// module id = Gh+d
// module chunks = 0